// A normal image link remains usable when dialog support or JavaScript is absent.
const posterLinks = document.querySelectorAll('[data-tournament-card-poster]');
let posterDialog;
let returnFocus;

function dialog() {
  if (posterDialog) return posterDialog;
  posterDialog = document.createElement('dialog');
  posterDialog.className = 'tournament-poster-dialog';
  posterDialog.setAttribute('aria-labelledby', 'tournament-poster-title');
  posterDialog.innerHTML = '<header><h2 id="tournament-poster-title"></h2><button type="button" autofocus>بستن</button></header><div class="tournament-poster-content"><img alt=""><p hidden>تصویر دریافت نشد. از پیوند اندازهٔ اصلی استفاده کنید.</p></div><a class="tournament-poster-original" target="_blank" rel="noopener">مشاهده در اندازهٔ اصلی</a>';
  document.body.append(posterDialog);
  const image = posterDialog.querySelector('img');
  image.addEventListener('error', () => {
    image.hidden = true;
    posterDialog.querySelector('p').hidden = false;
  });
  posterDialog.querySelector('button').addEventListener('click', () => posterDialog.close());
  posterDialog.addEventListener('keydown', event => {
    if (event.key !== 'Tab') return;
    const controls = [...posterDialog.querySelectorAll('button, a[href]')].filter(node => node.getClientRects().length);
    const first = controls[0], last = controls.at(-1);
    if (event.shiftKey && (document.activeElement === first || document.activeElement === posterDialog)) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first?.focus();
    }
  });
  posterDialog.addEventListener('click', event => {
    const box = posterDialog.getBoundingClientRect();
    if (event.target === posterDialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) posterDialog.close();
  });
  posterDialog.addEventListener('close', () => {
    document.body.classList.remove('tournament-poster-open');
    returnFocus?.focus({ preventScroll: true });
  });
  return posterDialog;
}

posterLinks.forEach(link => {
  const image = link.querySelector('.tournament-card-picture img');
  if (!image) return;
  const sync = () => {
    const failed = image.complete && !image.naturalWidth;
    link.classList.toggle('is-image-missing', failed);
    link.href = failed ? link.dataset.detailsUrl : image.currentSrc || image.src;
    link.setAttribute('aria-label', `${failed ? 'جزئیات' : 'نمایش پوستر'} ${link.dataset.posterTitle}`);
    if (failed) link.removeAttribute('target');
    else link.target = '_blank';
  };
  image.addEventListener('load', sync);
  image.addEventListener('error', sync);
  if (image.complete) sync();
  link.addEventListener('click', event => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || !image.naturalWidth || typeof HTMLDialogElement === 'undefined' || !HTMLDialogElement.prototype.showModal) return;
    event.preventDefault();
    returnFocus = link;
    const view = dialog();
    const title = link.dataset.posterTitle;
    view.querySelector('h2').textContent = title;
    const fullImage = view.querySelector('img');
    fullImage.alt = `پوستر ${title}`;
    fullImage.hidden = false;
    view.querySelector('p').hidden = true;
    fullImage.src = image.currentSrc || image.src;
    view.querySelector('a').href = fullImage.src;
    view.showModal();
    view.querySelector('button').focus({ preventScroll: true });
    document.body.classList.add('tournament-poster-open');
  });
});
